<template>
  <step :context="{}">
    <div class="congrats">
      <img src="/images/congrats.svg" />
      <div class="header">Tebrikler!</div>
      <div class="text">
        Como Sense Basic Paket ön-kurulumunuzu başarıyla tamamladınız.
        Sorularınızı yanıtlamak, taleplerinizi beraber değerlendirerek sadakat programının aktivasyonunu sağlamak ve eğitimi planlamak için bir müşteri temsilcimiz sizinle iletişime geçecektir.

        Aktivasyon tamamlandıktan sonra e-postanıza aşağıdaki materyalleri göndereceğiz:
        <ul>
          <li>Como Sense Yönetim Paneli kullanıcı adı ve geçici şifreniz</li>
          <li>Web siteniz ve sosyal ağlardan üye kaydı alabilmeniz için bir Üye Portalı bağlantısı</li>
          <li>İşletmenizde POS üzerinden otomatik üye kaydı alma ve promosyonları kullanma konusunda kılavuz videolar</li>
        </ul>
        Sorularınız için lütfen <a href="mailto:destek@bonobo.com.tr">destek@bonobo.com.tr</a> adresinden Müşteri Destek birimimize ulaşın.
      </div>
    </div>
  </step>
</template>

<script>
import Step from "./Step";
export default {
  components: {
    Step
  }
};
</script>

<style lang="scss" scoped>
.congrats {
  height: 100%;

  img {
    display: none;
  }
  background-image: url("/images/congrats.svg");
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-size: 68%;

  .header {
    font-size: 52px;
    font-weight: bold;
    color: #333d4d;
    margin: 58px 0 -10px;
  }

  .text {
    font-size: 18px;
    font-weight: 300;
    line-height: 1.56;
    max-width: 690px;
    color: #333d4d;
    white-space: pre-line;
    & .bold,a {
      font-weight: 500;
    }
    ul {
      list-style-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='10' viewBox='-1 -1 2 2'><circle r='0.4' /></svg>");
    }
    tab-size: 62px;
    text-shadow: white 1px 1px 1px;
  }

  #app.mobile & {
    height: fit-content;
    padding: 0 30px 40px;
    background-image: none;
    img {
      display: initial;
      width: 124vw;
      position: relative;
      left: calc(-15px - 12vw);
    }
    .header {
      font-size: 36px;
      margin: 0;
    }
  }
}
</style>